<template>
  <router-link to="/organizations" tag="li"><a><i class="fa fa-users"></i><span>Kerjasama</span></a></router-link>
</template>
<script>
export default {
  name: 'navigation-nav'
}
</script>





// WEBPACK FOOTER //
// Navigation.vue?e9e783bc